var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('naturalTxt'),_c('van-button',{staticClass:"btn",attrs:{"plain":"","type":"info","block":"","round":""},on:{"click":_vm.iKnowBtnClick}},[_vm._v("我知道了")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }